import { Button, Space, Tabs } from 'antd'
import { DeliveryCostsPanel } from '../../Settings/DeliveryCosts/DeliveryCostsPanel'
import { LineItemStatus } from '../LineItemStatus'
import { ArrowDown, ArrowUp, X } from 'lucide-react'
import { DimensionsPanel } from './Panels/DimensionsPanel'
import { MaterialsList } from '../../Materials/MaterialsList'
import { FinancialPanel } from './Panels/FinancialPanel'
import { ProductPanel } from './Panels/ProductPanel'
import { useFFEStore } from '../../../store/ffeStore'
import { useShallow } from 'zustand/react/shallow'

export const LineItemDetailsPanel = () => {
  const lineItems = useFFEStore((state) => state.document.lineItems)
  const { item, currentIndex } = useFFEStore(
    useShallow((state) => {
      const itemId = state.lineItemDetailsDrawerId
      const currentIndex = state.document.lineItems.findIndex(
        (item) => item.id === itemId
      )
      return { item: state.document.lineItems[currentIndex], currentIndex }
    })
  )
  const updateLineItem = useFFEStore((state) => state.updateLineItem)

  const handlePrevious = () => {
    const prevItem = lineItems[currentIndex - 1]
    if (prevItem) {
      useFFEStore.setState({ lineItemDetailsDrawerId: prevItem.id })
    }
  }

  const handleNext = () => {
    const nextItem = lineItems[currentIndex + 1]
    if (nextItem) {
      useFFEStore.setState({ lineItemDetailsDrawerId: nextItem.id })
    }
  }

  const handleUpdate = (updates: Partial<typeof item>) => {
    updateLineItem(item.id, updates)
  }

  const onClose = () => {
    useFFEStore.setState({ lineItemDetailsDrawerId: undefined })
  }

  const tabItems = [
    {
      key: 'product',
      label: 'Product',
      children: <ProductPanel item={item} />
    },
    {
      key: 'financial',
      label: 'Financial',
      children: <FinancialPanel item={item} />
    },
    {
      key: 'materials',
      label: 'Finishes',
      children: (
        <div className="overflow-y-auto p-6 max-h-[calc(100vh-110px)]">
          <MaterialsList accessories={false} lineItem={item} addButton={true} />
        </div>
      )
    },
    {
      key: 'accessories',
      label: 'Accessories',
      children: (
        <div className="overflow-y-auto p-6 max-h-[calc(100vh-110px)]">
          <MaterialsList accessories={true} lineItem={item} addButton={true} />
        </div>
      )
    },
    {
      key: 'dimensions',
      label: 'Dimensions',
      children: <DimensionsPanel item={item} />
    }
  ]

  const deliveryTabItems = [
    {
      key: 'delivery',
      label: 'Delivery',
      children: <div className='p-4'><DeliveryCostsPanel /></div>
    },
    {
      key: 'financial',
      label: 'Financial',
      children: <FinancialPanel item={item} />
    }
  ]

  const tabs = item.systemCategory === 'DELIVERY' ? deliveryTabItems : tabItems

  return (
    <>
      <div className="flex flex-row p-4">
        <div className="flex-1 flex items-center gap-4">
          <Button
            onClick={onClose}
            type="text"
            icon={<X className="h-5 w-5 text-gray-400" />}
          ></Button>
          <div className="flex-1 font-semibold text-md truncate max-w-[312px]">
            {`${item.code}${item.code ? ' - ' : ''}${item.name || 'Line Item Details'}`}
          </div>
        </div>
        <Space>
          <LineItemStatus item={item} onUpdate={handleUpdate} />

          <Button
            icon={<ArrowUp className="h-4 w-4" />}
            onClick={handlePrevious}
            disabled={currentIndex === 0}
          />
          <Button
            icon={<ArrowDown className="h-4 w-4" />}
            onClick={handleNext}
            disabled={currentIndex === lineItems.length - 1}
          />
        </Space>
      </div>

      <Tabs
        tabBarStyle={{ paddingLeft: 24, paddingRight: 24, marginBottom: 0 }}
        items={tabs}
      />
    </>
  )
}
